import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100 d-flex mt-8" }
const _hoisted_2 = { class: "mx-auto" }
const _hoisted_3 = { class: "fs-4 mb-3" }
const _hoisted_4 = { class: "fs-6 mb-3 text-danger" }

import RegisterModal from '@/components/Common/RegisterModal.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterModal',
  props: {
    modelValue: { type: Boolean },
    title: {},
    execFunction: { type: Function }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function exec() {
  props.execFunction();
  modelValue.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(RegisterModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
    modalMaxWidth: "45%",
    title: props.title
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.recreateConfirmModal.body')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.recreateConfirmModal.announce')), 1)
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_v_btn, {
        class: "ma-2 reset-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (modelValue.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        class: "ma-2 bg-danger text-white",
        onClick: exec
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.dailyReports.recreateConfirmModal.exec')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})